import PropTypes from 'prop-types'
import React from 'react'
import omit from 'lodash/omit'

import { toTitle } from '../../../../common/utils/formatString'
import {
  makeLink,
  getQueryWithoutCategory,
  getQueryWithoutOption
} from '../../../../common/utils/urlHelper'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'

const createLabelMapping = () => {
  const prepend = (labels, prefix) => {
    const prefixedLabels = {}
    Object.keys(labels).forEach(key => {
      prefixedLabels[key] = `${prefix} ${labels[key]}`
    })
    return prefixedLabels
  }

  const sizeLabels = prepend(filterParamsConfig.sizes.labels, 'Size')
  const salesLabels = prepend(filterParamsConfig.sales.labels, 'Sale')
  return Object.assign(sizeLabels, salesLabels)
}

const FilterList = ({ FilterItem, parsedLocation, param }) => {
  // if the fitler is not in the config, simply return null
  if (!filterParamsConfig[param] || !parsedLocation[param]) return null

  if (filterParamsConfig[param].isMultiple) {
    const labelMapping = createLabelMapping()
    return (
      <ul>
        {parsedLocation[param]
          .split(filterParamsConfig[param].delimiter)
          .map((option, index) => {
            let link, newQuery
            let displayName = labelMapping[option] || toTitle(option)

            // category is separate by '/' eg. 'category/wordpress/clean'
            if (filterParamsConfig[param].delimiter === '/') {
              newQuery = getQueryWithoutCategory(parsedLocation, param, option)
              // tags
            } else if (filterParamsConfig[param].delimiter === ',') {
              newQuery = getQueryWithoutOption(parsedLocation, param, option)
            }
            // reset page param
            delete newQuery.page
            link = makeLink(newQuery)
            if (displayName) {
              return (
                <FilterItem
                  paramType={param}
                  displayName={displayName}
                  link={link}
                  key={index}
                  index={index}
                />
              )
            } else {
              return null
            }
          })}
      </ul>
    )
  } else {
    if (filterParamsConfig[param].inRangeWith) {
      const minRangeParam = filterParamsConfig[param].inRangeWith.min || param
      const maxRangeParam = filterParamsConfig[param].inRangeWith.max || param
      const minParamValue = parsedLocation[minRangeParam]
      const maxParamValue = parsedLocation[maxRangeParam]

      // combine price_min and price_max if both exist
      if (minParamValue && maxParamValue) {
        const minParamFormatValue = filterParamsConfig[param].format
          ? filterParamsConfig[param].format(minParamValue)
          : minParamValue
        const maxParamFormatValue = filterParamsConfig[param].format
          ? filterParamsConfig[param].format(maxParamValue)
          : maxParamValue
        const priceDisplayName = `${minParamFormatValue} - ${maxParamFormatValue}`
        const link = makeLink(
          omit(parsedLocation, [minRangeParam, maxRangeParam, 'page'])
        )
        return (
          <ul>
            <FilterItem
              paramType={param}
              displayName={priceDisplayName}
              link={link}
              index={0}
            />
          </ul>
        )
      } else {
        const paramFormatValue = filterParamsConfig[param].format
          ? filterParamsConfig[param].format(parsedLocation[param])
          : parsedLocation[param]
        const priceDisplayName = `${filterParamsConfig[param]
          .label} ${paramFormatValue}`
        const link = makeLink(omit(parsedLocation, [param, 'page']))
        return (
          <ul>
            <FilterItem
              paramType={param}
              displayName={priceDisplayName}
              link={link}
              index={0}
            />
          </ul>
        )
      }
    } else {
      let label = parsedLocation[param]
      let link = makeLink(omit(parsedLocation, [param, 'page']))
      if (param === 'sort_by' && parsedLocation['sort_direction']) {
        // parse label for sort_by filter
        label =
          parsedLocation['sort_by'] + '-' + parsedLocation['sort_direction']
        // when it's a sort by filter, we remove the `sort_direction`
        // as well when clear
        link = makeLink(omit(parsedLocation, [param, 'page', 'sort_direction']))
      }
      let displayName = !filterParamsConfig[param].labels
        ? parsedLocation[param]
        : filterParamsConfig[param].labels[label]

      if (filterParamsConfig[param].format) {
        displayName = filterParamsConfig[param].format(displayName)
      }

      return (
        <ul>
          <FilterItem
            paramType={param}
            displayName={displayName}
            link={link}
            index={0}
          />
        </ul>
      )
    }
  }
}

FilterList.propTypes = {
  parsedLocation: PropTypes.object.isRequired,
  param: PropTypes.string.isRequired
}

export default FilterList



// WEBPACK FOOTER //
// ./client/components/filters/selectedFilters/filterList.js